import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedFilters: [],
  myTasks: false,
  selectedSort: 1,
  sortDirection: 'asc',
  selectedTaskFilter: [],
  selectedClient: [],
  selctedTeam: [],
  selectedPriority: [],
  selectedDate: [],
  selectedProduct: [],
  selectedAssignee: [],
  selectedProject: []
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSelectedFilters: (state, action) => {
      state.selectedFilters = action?.payload;
    },
    setSelectedSort: (state, action) => {
      state.selectedSort = action?.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action?.payload;
    },
    setSelectedTaskFilter: (state, action) => {
      state.selectedTaskFilter = action?.payload;
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action?.payload;
    },
    setSelectedTeam: (state, action) => {
      state.selctedTeam = action?.payload;
    },
    setSelectedPriority: (state, action) => {
      state.selectedPriority = action?.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action?.payload;
    },
    setSelectedProduct: (state, action) => {
      state.selectedProduct = action?.payload;
    },
    setSelectedAssignee: (state, action) => {
      state.selectedAssignee = action?.payload;
    },
    setSelectedProject: (state, action) => {
      state.selectedProject = action?.payload;
    },
    setMyTasks: (state, action) => {
      state.myTasks = action?.payload;
    },
    setOnlySelectedDate: (state, action) => {
      state.selectedFilters = ['Due Date'];
      state.myTasks = true;
      state.selectedSort = 1;
      state.sortDirection = 'asc';
      state.selectedTaskFilter = [];
      state.selectedClient = [];
      state.selctedTeam = [];
      state.selectedPriority = [];
      state.selectedDate = action?.payload;
      state.selectedProduct = [];
      state.selectedAssignee = [];
      state.selectedProject = [];
    },
    clearFilter: (state) => {
      state.selectedFilters = [];
      state.selectedTaskFilter = [];
      state.selectedClient = [];
      state.selctedTeam = [];
      state.selectedPriority = [];
      state.selectedDate = [];
      state.selectedProduct = [];
      state.selectedAssignee = [];
      state.selectedProject = [];
    }
  }
});

export const {
  setSelectedFilters,
  setSelectedSort,
  setSortDirection,
  setSelectedTaskFilter,
  setSelectedClient,
  setSelectedTeam,
  setSelectedPriority,
  setSelectedDate,
  setSelectedProduct,
  setSelectedAssignee,
  setSelectedProject,
  setOnlySelectedDate,
  setMyTasks,
  clearFilter
} = dashboardSlice?.actions;

export default dashboardSlice?.reducer;
